import _ from "lodash";
import {HTML_CONTENT_TYPE_HEADERS, HTML_CONTENT_TYPE_LIST_ITEMS} from "../constants/content.constant";
import {updateSingleBlogPost} from "../services/blog-post-data-service";

export {
    prepareHtmlContentDetails,
    addTextForContentLine,
    markAsDraftBlogPost,
    markAsReadyBlogPost,
    markAsPublishedBlogPost,
    processContentLines,
    isTextFoundInContentLine,
    findTextIndexInContentLine,
    prepareContentStatistics,
    addImagesToContentLines,
    removeSectionHeader,
}

const processContentLines = (contentLines) => {
    let currentSection = '';

    _.forEach(contentLines, (contentLine, contentLineIndex) => {
        if (contentLine.isSection) {
            if (!(contentLine.newType === 'h2' || contentLine.type === 'h2')) {
                contentLine.isSection = false;
            }
        } else if (!contentLine.isSection) {
            if (contentLine.newType === 'h2' || contentLine.type === 'h2') {
                contentLine.isSection = true;
                contentLine.section = '';
            }
        }

        if (contentLine.isSection) {
            currentSection = contentLine.text;
        } else {
            contentLine.section = currentSection;
        }

        if (contentLine.newType === 'end') {
            contentLine.section = '';
        }
    });
}
const prepareHtmlContentDetails = (existingContentLines, existingSectionTitlesMap?, populateFirstTime?) => {
    const contentLinesHtml = existingContentLines?.map((contentLine, index) => {
        let htmlOutput = '';
        let htmlInput = contentLine.html || '';
        let textInput = contentLine.text;

        if (!_.isEmpty(contentLine.links) && contentLine.newType !== 'h3') {
            const updatedDetail = prepareTextLinks(contentLine, textInput, htmlInput);
            textInput = updatedDetail.textInput;
            htmlInput = updatedDetail.htmlInput;
        }

        if (contentLine?.text?.indexOf(':') !== -1 && HTML_CONTENT_TYPE_LIST_ITEMS.indexOf(contentLine.type) !== -1) {
            const htmlInputList = _.split(textInput, ':');
            htmlInputList[0] = `<u><b>${htmlInputList[0]}</b></u>`;

            htmlInput = htmlInputList.join(':');
        }

        if (contentLine.newType) {
            if (contentLine.isImage) {
                htmlOutput += `</br><p>${htmlInput}</p></br>`;
            } else if (contentLine.newType === 'br' || contentLine.newType === 'end') {
                if (index !== 0) {
                    htmlOutput += `</br><p>${textInput}</p>`;
                } else {
                    htmlOutput = textInput;
                }
            } else {
                if (index !== 0 && HTML_CONTENT_TYPE_HEADERS.indexOf(contentLine.newType) !== -1) {
                    htmlOutput = `</br>`;
                }

                htmlOutput += `<${contentLine.newType}>${textInput}</${contentLine.newType}>`;
            }
        } else {
            if (contentLine.first) {
                htmlOutput = `<${contentLine.parentType}>${htmlInput}`;
            } else if (contentLine.last) {
                htmlOutput = `${htmlInput}</${contentLine.parentType}>`;
            } else {
                htmlOutput = htmlInput;
            }
        }

        if (contentLine.isSection) {
            if (existingSectionTitlesMap && !existingSectionTitlesMap.hasOwnProperty(textInput)) {
                existingSectionTitlesMap[textInput] = !populateFirstTime;
            }
        }

        if (contentLine.newType === 'h3') {
            console.log('contentLine', contentLine);
            console.log('htmlOutput', htmlOutput);
            console.log('textInput', textInput);
            console.log('htmlInput', htmlInput);
        }

        return htmlOutput;
    });

    return contentLinesHtml.join('');
}

const prepareTextLinks = (contentLine, textInput, htmlInput) => {
    const reversedLinks = _.sortBy(contentLine.links, ['textIndex']).reverse();

    _.forEach(reversedLinks, (link) => {
        const startIndex = textInput.toLowerCase().indexOf(link?.value.toLowerCase());
        const endIndex = startIndex + link?.value.length;

        if (startIndex > -1) {
            let searchText = textInput.substring(startIndex, endIndex);
            searchText = _.trim(searchText);

            const textLink = `<a href="${link?.url}" target="_blank">${searchText}</a>`
            textInput = textInput.replace(searchText, textLink);
            htmlInput = htmlInput.replace(searchText, textLink);
        } else {
            console.log({linkValue: link?.value, textInput});
        }
    });

    return {textInput, htmlInput};
}

const addTextForContentLine = (existingContentLines, sectionContentLines, selectedContentLineIndex) => {
    const firstArray = existingContentLines.slice(0, selectedContentLineIndex + 1);
    const secondArray = existingContentLines.slice(selectedContentLineIndex + 1);
    return firstArray.concat(sectionContentLines, secondArray);
}

const markAsDraftBlogPost = async (existingBlogPost) => {
    existingBlogPost.status = 'Draft';
    await updateSingleBlogPost(existingBlogPost);
}

const markAsReadyBlogPost = async (existingBlogPost) => {
    existingBlogPost.status = 'Ready';
    await updateSingleBlogPost(existingBlogPost);
}

const markAsPublishedBlogPost = async (existingBlogPost) => {
    existingBlogPost.status = 'Published';
    await updateSingleBlogPost(existingBlogPost);
}

const isTextFoundInContentLine = (inputText, searchText) => {
    const text = inputText.toLowerCase();
    const search = searchText.toLowerCase();

    return text.indexOf(search) !== -1;
}

const findTextIndexInContentLine = (inputText, searchText) => {
    const text = inputText.toLowerCase();
    const search = searchText.toLowerCase();

    return text.indexOf(search);
}

const prepareContentStatistics = (existingContentLines, generatedText) => {
    const statistics: any = {};
    let totalParagraphs = 0;
    let totalImages = 0;
    let totalSections = 0;
    let totalLinks = 0;

    _.forEach(existingContentLines, (contentLine) => {
        if (contentLine.isImage) {
            totalImages++;
        } else if (contentLine.isSection) {
            totalSections++;
        } else {
            totalParagraphs++;
            if (!_.isEmpty(contentLine?.links)) {
                totalLinks += contentLine?.links?.length;
            }
        }
    });

    statistics.requiredImagesCount = Math.ceil(totalParagraphs / 2);
    statistics.totalParagraphs = totalParagraphs;
    statistics.totalImages = totalImages;
    statistics.totalLinks = totalLinks;
    statistics.totalSections = totalSections;
    statistics.words = _.words(generatedText).length;
    statistics.characters = generatedText.length;

    return statistics;
}

const addImagesToContentLines = (productImages, existingContentLines) => {
    const newContentLines = [];
    let lineIndex = 0;
    let imageIndex = -1;
    const shuffledProductImages = _.shuffle(_.cloneDeep(productImages));

    _.forEach(existingContentLines, (contentLine) => {
        if (!contentLine.isImage) {
            newContentLines.push(contentLine);
        }

        if (!contentLine.isImage && !contentLine.isSection) {
            lineIndex++;

            if (lineIndex % 2 === 0) {
                imageIndex++;
                const productImage = shuffledProductImages[imageIndex];

                const imageLine = {
                    key: "P",
                    type: "p",
                    text: productImage.productTitle,
                    html: `<a href="${productImage?.onlineStoreUrl}" target="_blank"><img src="${productImage?.url}" alt="${productImage.productTitle}"></a>`,
                    newType: "br",
                    isImage: true,
                    productImageId: productImage.id,
                    url: productImage?.url
                }

                newContentLines.push(imageLine);
            }
        }
    });

    return newContentLines;
}

const removeSectionHeader = (inputString) => {
    const regex = /^(Section \d+:)\s*/;
    let updatedString = inputString.replace(regex, "");
    updatedString = removeStartingHashes(updatedString);

    updatedString = updatedString.replace(/^\*\*/, "");

    if (updatedString.endsWith("**")) {
        updatedString = updatedString.substring(0, updatedString.length - 2);
    }

    return updatedString;
}

const removeStartingHashes = (updatedString: any) => {
    const regex = /^(####|###|##|#)\s*/;
    return updatedString.replace(regex, "");
}
